import type { Theme } from '@mui/material/styles';

const getMuiInputLabel = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      fontSize: theme.typography.h6.fontSize,
    }),
    outlined: ({ theme }: { theme: Theme }) => ({
      minHeight: '20px',
      lineHeight: '14px',
      color: theme.palette.semantic.text.primary,
      borderRadius: theme.shape.borderRadius,
      transform: `translate(12px, 12px)`,
      '&.MuiInputLabel-sizeSmall': {
        transform: `translate(12px, 8px)`,
      },
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, -6px) scale(0.785)',
        borderRadius: theme.shape.borderRadius,
        background: theme.palette.semantic.surface.default,
        boxShadow: `0 0 0 2px ${theme.palette.semantic.surface.default}`,
        minHeight: 0,
        color: theme.palette.semantic.text.primary,
        '&.Mui-disabled': {
          color: theme.palette.semantic.text.placeholder,
          background: theme.palette.semantic.background.default,
          boxShadow: `0 0 0 2px ${theme.palette.semantic.background.default}`,
        },
        '&.Mui-error': {
          color: theme.palette.semantic.ui.critical,
        },
      },
    }),
  },
});
export default getMuiInputLabel;
